<!-- Loader -->
@if (showFormLoader || signOffLoading) {
<div class="formLoader">
  <i class="fa fa-spinner fa-spin gt-refresh"></i>
</div>
}

<!-- Main content -->
@if (filtersSelected && !signOffLoading) {
<div>

  <!-- Sign Off Header / Filters -->
  <div class="sign-off-hdr">
    <div class="drop-dwn">
      <label>Sign Off Month:</label>
      <select class="form-control data-filters"
              [ngModel]="monthSearch"
              (ngModelChange)="monthSearch = $event; onMonthChange()">
        @for (m of monthFilterList; track $index) {
<option [ngValue]="m">{{ m.name }}</option>
}
      </select>
    </div>

    <div class="busines">
      <div class="data-filters bu-dropdown-wrapper">
        <button class="bu-dropdown-btn" type="button" (click)="buDropdownOpen = !buDropdownOpen">
          Select BU(s)
          <i class="fa fa-caret-down" style="margin-left: 5px;"></i>
        </button>
        @if (buDropdownOpen) {
<div class="bu-dropdown-panel">
          @for (bu of buFilterValues; track $index) {
<div class="bu-dropdown-item">
            <label>
              <input type="checkbox"
                     [checked]="buFilterModel.indexOf(bu.value) !== -1"
                     (change)="toggleBuFilter(bu.value)" />
              {{ bu.name }}
            </label>
          </div>
}
        </div>
}
      </div>
    </div>

    <div class="search-part">
      <i class="fa fa-search" aria-hidden="true"></i>
      <input type="text" class="form-control data-filters"
             placeholder="Search Business"
             [ngModel]="searchText"
             (ngModelChange)="searchText = $event; onSearchChange()" />
    </div>
  </div>

  <!-- Sign Off List -->
  @for (list of displayedList; track $index; let i = $index) {
<div
       class="sign-off-list-wrapper"
       [ngClass]="{'green-border': list.SIGNED_OFF == 1}">

    <!-- Business Name -->
    <div class="text-center bus-name">
      <b>{{ list.PARENT_ME_NAME }}</b>
    </div>

    <!-- Middle: checkbox + desc + edit icon -->
    <div class="list-trunc">
      <div class="checkbox-col">
        <input type="checkbox"
               [id]="'signoff_' + i"
               [checked]="list.SIGNED_OFF == 1"
               (click)="onCheckboxChange(list)"
               style="margin-right: 10px; transform: scale(1.3);" />
      </div>
      <div class="comment">
        {{ list.SIGN_OFF_DESC }}
      </div>
      <div class="edit-col" style="border-left: 1px solid #ccc;">
        <i class="fa fa-pencil-square-o edt-icn" (click)="openEditModal(list)"></i>
      </div>
    </div>

    <!-- Sign Off Details -->
    <div class="sign-off-details">
      <div>Signed Off By: <b>{{ list.SIGNED_OFF_BY }}</b></div>
      <div>Signed Off date: <b>{{ list.DATE_SIGNED_OFF }}</b></div>
    </div>
  </div>
}

  <!-- Empty state -->
  @if (displayedList.length === 0 && filtersSelected) {
<div class="no-data-msg">
    No sign-off data found for the selected filters.
  </div>
}
</div>
}
